module.exports = __webpack_public_path__ + "media/images/icons/side_menu_assegnare_attivo-43ff25b0f497a414d17dc6e169ba5418.svg";